"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breakpoint = exports.ServiceLevelTypes = void 0;
var ServiceLevelTypes;
(function (ServiceLevelTypes) {
    ServiceLevelTypes["DailyMedService"] = "dailymedservice";
    ServiceLevelTypes["DailyMedInstitutionCare"] = "dailymedinstitutioncare";
    ServiceLevelTypes["HomeCare"] = "homecare";
    ServiceLevelTypes["ServiceCare"] = "servicecare";
    ServiceLevelTypes["InstitutionCare"] = "institutioncare";
    ServiceLevelTypes["AdditionalCare"] = "additionalcare";
})(ServiceLevelTypes || (exports.ServiceLevelTypes = ServiceLevelTypes = {}));
var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["none"] = 0] = "none";
    Breakpoint[Breakpoint["small"] = 0] = "small";
    Breakpoint[Breakpoint["medium"] = 1] = "medium";
    Breakpoint[Breakpoint["large"] = 2] = "large";
    Breakpoint[Breakpoint["xlarge"] = 3] = "xlarge";
    Breakpoint[Breakpoint["xxlarge"] = 4] = "xxlarge";
})(Breakpoint || (exports.Breakpoint = Breakpoint = {}));
//# sourceMappingURL=applicationState.js.map